<template>
  <div>
    <div v-if="loading" style="padding-top: 100px;" class="container has-text-centered opaque">
      <i class="fa fa-refresh fa-spin fa-4x"></i>
      <p>Loading...</p>
    </div>
    <div v-if="!loading">
      <div class="container" style="min-height: 35rem;">
        <section class="section">
          <h1 class="request-title">Request Certificate of Property Insurance</h1>
          <AssociationPin v-if="stage === 1" :hasTenant="hasTenant" :agencies="agencies" @tenantSelected="tenantSelected" @next="getAssociation"
            @cancel="cancel" :Request="Request" :showNotFound="showNotFound"></AssociationPin>
          <PropertyInformation v-if="stage === 2" @next="next" @previous="previous" @cancel="cancel" :Request="Request"></PropertyInformation>
          <FinalizeRequest v-if="stage === 3" @finalize="finalize" @previous="previous" @cancel="cancel" :Request="Request"></FinalizeRequest>
          <RequestComplete v-if="stage === 4" :accord24="Request.Association.Accord24" :association="Request.Association"></RequestComplete>
          <div class="container" v-if="tenantLongName != null && tenantPhoneNumber != null">
            <p style="margin-top: 20px;" class="has-text-centered has-text-grey is-size-6">Questions or issues? Call {{tenantLongName}} at {{tenantPhoneNumber}}.</p>
          </div>
        </section>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import AssociationPin from './AssociationPin'
  import PropertyInformation from './PropertyInformation'
  import FinalizeRequest from './FinalizeRequest'
  import RequestComplete from './RequestComplete'
  import Footer from '@/Footer'
  import tenant from '@/tenant'
  export default {
    name: 'Request',
    data: function () {
      return {
        loading: true,
        submitted: false,
        showNotFound: false,
        found: false,
        hasTenant: false,
        stage: 1,
        tenantName: '',
        tenantLongName: null,
        tenantPhoneNumber: null,
        agencies: [],
        Request: {
          PinNumber: '',
          PropertyOwnerName: '',
          PropertyAddress: '',
          LoanNumber: '',
          CertificateHolder: '',
          RequesterEmail: '',
          RequesterName: '',
          Date: ''
        }
      }
    },
    methods: {
      next() {
        this.stage++
      },
      previous() {
        this.stage--
      },
      finalize() {
        this.Request.Association.Accord24.CertificateHolder = this.Request.CertificateHolder
        this.Request.Association.Accord24.AdditionalRemarks = this.Request.Association.Accord24.AdditionalRemarks || ''
        if (this.Request.PropertyOwnerName) {
          this.Request.Association.Accord24.AdditionalRemarks += '<br><br>PROPERTY OWNER NAME:  ' + this.Request.PropertyOwnerName
        }
        if (this.Request.PropertyAddress) {
          this.Request.Association.Accord24.AdditionalRemarks += '<br><br>PROPERTY ADDRESS:  ' + this.Request.PropertyAddress
        }
        if (this.Request.LoanNumber) {
          this.Request.Association.Accord24.AdditionalRemarks += '<br><br>LOAN NUMBER:  ' + this.Request.LoanNumber
        }
        this.postRequest()
        this.stage++
      },
      cancel() {
        this.$router.push('/')
      },
      tenantSelected(tenantName) {
        this.tenantName = tenantName
        tenant.firebaseDb.ref('lists/agencies/' + tenantName).once('value').then(snapshot => {
          this.tenantLongName = snapshot.val().name
          this.tenantPhoneNumber = snapshot.val().phone
        })
      },
      getAssociation() {
        this.showNotFound = false
        axios.get(process.env.API_BASE_URL + '/api/' + this.tenantName + '/certificates?PinNumber=' + this.Request.PinNumber)
          .then((response) => {
            this.Request.Association = response.data
            this.next()
            this.loading = false
          }).catch((error) => {
            if (error.response) {
              if (error.response.status === 404) {
                this.showNotFound = true
              }
            }
            console.log(error)
          })
      },
      postRequest() {
        this.Request.Date = new Date().toISOString()
        axios.post(process.env.API_BASE_URL + '/api/' + this.tenantName + '/requests', this.Request)
          .then((response) => {
            console.log(response)
          }).catch((error) => {
            if (error.response) {
              if (error.response.status === 404) {
                this.showNotFound = true
              }
            }
            console.log(error)
          })
      },
      setTenantDetails(tenantVal) {
        if (tenantVal) {
          this.tenantLongName = tenantVal.name
          this.tenantPhoneNumber = tenantVal.phone
        }
      }
    },
    mounted: function () {
      this.tenantName = this.$route.params.tenantName
      this.Request.PinNumber = this.$route.params.pinNumber

      if (this.tenantName && this.Request.PinNumber) {
        tenant.firebaseDb.ref('lists/agencies/' + this.tenantName).once('value').then(snapshot => {
          this.setTenantDetails(snapshot.val())
          this.getAssociation()
          this.hasTenant = true
        })
      } else if (this.tenantName && !this.Request.PinNumber) {
        tenant.firebaseDb.ref('lists/agencies/' + this.tenantName).once('value').then(snapshot => {
          this.setTenantDetails(snapshot.val())
          this.hasTenant = true
          this.loading = false
        })
      } else {
        tenant.firebaseDb.ref('lists/agencies').once('value').then(snapshot => {
          this.agencies = snapshot.val()
          this.loading = false
        })
      }
    },
    components: {
      AssociationPin,
      PropertyInformation,
      FinalizeRequest,
      RequestComplete,
      Footer
    }
  }

</script>

<style scoped>
  .request-title {
    margin-bottom: 20px;
    font-size: 24px;
  }
</style>


// WEBPACK FOOTER //
// src/components/request/Request.vue?38f64180